/** Pure scale helpers for the in-house SVG chart kit. Mirrors d3-scale's core, no dependency. */

/** Maps a value from the `[d0,d1]` domain onto the `[r0,r1]` range linearly (no clamping). */
export const scaleLinear =
  ([d0, d1]: [number, number], [r0, r1]: [number, number]) =>
  (v: number): number => {
    const span = d1 - d0 || 1;
    return r0 + ((v - d0) / span) * (r1 - r0);
  };

/** Clamps `n` into `[lo,hi]`. */
export const clamp = (n: number, lo: number, hi: number): number => Math.max(lo, Math.min(hi, n));

export interface BandScale {
  /** left edge of band `i` (after inner padding) */
  x: (i: number) => number;
  /** width of each band, inner padding removed */
  bandwidth: number;
  /** distance between consecutive band starts */
  step: number;
}

/** Evenly divides `[r0,r1]` into `count` bands with fractional inner padding (`0..1`). */
export const scaleBand = (count: number, [r0, r1]: [number, number], padding = 0): BandScale => {
  const step = count > 0 ? (r1 - r0) / count : 0;
  const bandwidth = step * (1 - padding);
  const offset = (step - bandwidth) / 2;
  return { step, bandwidth, x: (i: number) => r0 + i * step + offset };
};
